const nameProyectFirebase = 'bluewayqa';
const apiKeyFirebase = 'AIzaSyDdZJ5_r5wOm8iJTptQpR3XX-D6dpwEJT4';
const messageSenderId = '80196997067';
const appId = '1:80196997067:web:190e7264cc227099f5704e';
const measurementId = 'G-24VE9G2PVB';
const firebaseNotificationSend = 'https://fcm.googleapis.com/fcm/send';
const keyPairCloudMessageWeb = 'BHUpdGdNh6V-LzhZN22MLlD7v2zeK4p3LkA87DXSnuraGXsD2qJBo6hQABK5o9BRDz-h9kNZQbeUc0k-YMaa57A';
const keyMessaging = 'AAAAEqwdD8s:APA91bEr0V5w5fhO2ZpWH4zWlh8hnUQfXSkibrr5-noDtD3NTA84Exjkw0f4mJ1vLB9lslb18dMCtIXq1RxpwugtxOg_2cxjH7QpLbXWTqclYa_UMa8bY8dHnfY5-UVwDVLV1D6Dctds';

//cambiar en diferentes ramas de entornos.
/*
const nameProyectFirebase = 'bluewaydemo-4249c';
const apiKeyFirebase = 'AIzaSyAu506t68rtAVDxw8Hnvdg_rGNk4-pVqBk';
const messageSenderId = '650987406901';
const appId = '1:650987406901:android:8658413da05e5e784f137c';
const measurementId = 'G-24VE9G2PVB';
const firebaseNotificationSend = 'https://fcm.googleapis.com/fcm/send';
const keyPairCloudMessageWeb = 'BBBZirIkUiD22bEy5yod4bSmKcZ2BfEUTBaKvTxf9TePTxxyUp0NzP6r_cz0LqVl8G4ym3m3LOkwX3mSoT331nw';
//cloud messagin
const keyMessaging = 'AAAAl5HfhjU:APA91bHLiWC3q82n5Qz6RjrnjsQekSU43Mi2adE3VvcYOaRo5Ztu0djaNGE9RBRgV7ma59IvBamRTqQTPu53cfzmnUWeflxx10tvH9k0qW2APCbpiUEdwXd8CHoIwrZY-UZCh4EY75uO';
*/
const firebase = {
    "nameProyectFirebase": nameProyectFirebase,
    "apiKeyFirebase": apiKeyFirebase,
    "messageSenderId": messageSenderId,
    "appId": appId,
    "measurementId": measurementId,
    "keyMessaging": keyMessaging,
    "firebaseNotificationSend": firebaseNotificationSend,
    "keyPairCloudMessageWeb": keyPairCloudMessageWeb
};
export default firebase;
